export const EDIT_CLASS_PAGE_TRACKINGS = {
  classTemplateBulkUpdate: 'class_template_bulk_update',
} as const;
